import {Component, HostListener, OnInit, ViewEncapsulation} from '@angular/core';
import {AppState} from './app.service';
import {Auth} from './shared/services/auth';
import {Configuration} from './shared/services/configuration';
import {HttpClientCustom} from './shared/services/http.client';
import * as _ from 'underscore';
import {PermissionHelper} from './shared/permissions/permissions';
import {TranslateService} from '@ngx-translate/core';
import {environment} from './environment';
import '../styles/styles.scss';

@Component({
    selector: 'app-root',
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        './app.component.css'
    ],
    template: `
        <header *ngIf="loadTabs"></header>
        <router-outlet *ngIf="loadTabs"></router-outlet>
        <div class="loading1" *ngIf="showLoading">
            <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center">
                <img src="./assets/img/load.gif" alt="loading" width="80px">
            </div>
            <div class="loader-div">
                <div class="loader-gif"></div>
            </div>
        </div>
    `
})
export class AppComponent implements OnInit {

    public angularclassLogo = 'assets/img/angularclass-avatar.png';
    public name = 'Angular 2 Webpack Starter';
    public url = 'https://twitter.com/AngularClass';
    public showLoading: any = false;
    public _baseUrl: any;
    public loadTabs: any = false;

    constructor(
        public appState: AppState,
        public _auth: Auth,
        public _global: Configuration,
        public _http: HttpClientCustom,
        public _per: PermissionHelper,
        translate: TranslateService) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        let data = JSON.parse(localStorage.userInfo);
        if (data.localeName == null) {
            data.localeName = 'en_US';
        }
        document.documentElement.setAttribute('lang', data.localeName);
        translate.setDefaultLang(data.localeName);
        document.title = environment.appTitle;
        document.documentElement.setAttribute('client', environment.client);
    }

    get isAuthenticated(): boolean {
        return this._auth.isAuthenticated;
    }

    public ngOnInit() {
        this.getAllPermission();
    }

    public loader(option) {
        this.showLoading = option;
    }

    public getAllPermission() {
        let that = this;
        let permission: any = [];
        if (that.isAuthenticated) {
            let url = that._baseUrl + 'v1/hub/getAdminOperations';
            that._http.get(url).subscribe((result) => {
                if (result.length > 0) {
                    _.each(result, function (key, val) {
                        if (key.childOperations.length > 0) {
                            permission.push(key.operation);
                            _.each(key.childOperations, function (k, e) {
                                permission.push(k.operation);
                            });
                        }
                    });

                }
                that._per.savePermission(permission);
                that.loadTabs = true;
            });
        }

    }

    @HostListener('window:unload', ['$event'])
    public unloadHandler(event) {
    }

    @HostListener('window:beforeunload', ['$event'])
    public beforeUnloadHander(event) {
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts